"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefs = window.cccisd.appDefs;
var match = {};
var _default = exports["default"] = function _default(_ref) {
  var _ref$extraProps = _ref.extraProps,
    extraProps = _ref$extraProps === void 0 ? {} : _ref$extraProps;
  return function (WrappedComponent) {
    var _Class;
    return _Class = /*#__PURE__*/function (_React$Component) {
      function _Class() {
        _classCallCheck(this, _Class);
        return _callSuper(this, _Class, arguments);
      }
      _inherits(_Class, _React$Component);
      return _createClass(_Class, [{
        key: "render",
        value: function render() {
          var _this = this;
          var tabList = [];
          AppDefs.sessions.sessionTabs.forEach(function (s) {
            var Component = match[s.componentHandle];
            var sessions = [];
            s.sessions.forEach(function (sessionHandle) {
              var fullSession = (0, _find2["default"])(AppDefs.sessions["".concat(AppDefs.sessions.sessionType, "Settings")].sessions, function (session) {
                return session.handle === sessionHandle;
              });
              sessions.push(fullSession);
            });
            tabList.push({
              name: s.handle,
              title: s.label,
              content: /*#__PURE__*/_react["default"].createElement(Component, _extends({
                key: s.handle,
                appDefData: AppDefs.sessions,
                sessionData: sessions,
                pawn: _this.props.pawn
              }, Object.assign({}, (0, _omit2["default"])(_this.props, ['loading']), extraProps, s.componentProps)))
            });
          });
          var sessionDataComponent = {};
          if (this.props.loading) {
            sessionDataComponent = /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
              loading: this.props.loading
            });
          } else if (this.props.clients.length === 0) {
            sessionDataComponent = /*#__PURE__*/_react["default"].createElement("div", null, "No ".concat(extraProps.clientLabel, "s at this time."));
          } else {
            sessionDataComponent = /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
              tabList: tabList
            });
          }
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(WrappedComponent, this.props), sessionDataComponent);
        }
      }]);
    }(_react["default"].Component), _defineProperty(_Class, "propTypes", {
      // props from wrapped component
      pawn: _propTypes["default"].object,
      loading: _propTypes["default"].bool,
      clients: _propTypes["default"].array
    }), _Class;
  };
};